import { log } from '@utils/logging';
import GeneralInfoStep from './GeneralInfoStep';
import ConductStep from './ConductStep';
import StripeLinkStep from '@molecules/StripeLinkStep';
import { TeamForm } from './CreateTeamUtils';
import { useFormContext } from 'react-hook-form';

export const GENERAL: number = 0;
export const CODE_OF_CONDUCT: number = 1;
export const STRIPE_STEP: number = 2;

interface StepProps {
    step: number;
}

export default function CreateTeamSteps(props: StepProps) {
    const { step } = props;

    const { watch } = useFormContext<TeamForm>();
    const [payToUserId] = watch(['payToUserId']);

    switch (step) {
        case GENERAL:
            return <GeneralInfoStep />;
        case CODE_OF_CONDUCT:
            return <ConductStep />;
        case STRIPE_STEP:
            return <StripeLinkStep connectedAccountId={payToUserId} />;

        default:
            log(`Invalid CreateTeam step reached: ${step}`);
            return null;
    }
}
